import GetContactIdMappingsRequestModelBase from '../_generated/modelBases/get-contact-id-mappings-request-model-base';

export default class GetContactIdMappingsRequestModel extends GetContactIdMappingsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
